// @flow

import environment from '../config/environment';
// import AnalyticsService from './analyticsService';

import { Cookies } from 'react-cookie';
const testUrl = environment.fantasyLabsApiUrl_test;
const baseUrl = environment.fantasyLabsApiUrl;

export default class FantasyLabsService {
    cookies = new Cookies();

    executeFetch(
        route: string,
        params: { [key: string]: any },
        tag: string,
        failedAction: Function,
        successAction: Function
    ) {
        // const trackTitle = `API_${params.method}_${tag}`;
        // AnalyticsService.trackEvent(trackTitle, { url: route, method: params.method });
        return fetch(route, params)
            .then(res => res.json())
            .then(json => successAction(json))
            .catch(err => () => {
                // const errorMessage = `${err.name}: ${err.message} - fetching "${route}"`;
                // AnalyticsService.trackError(errorMessage, {
                //     url: route,
                //     name: err.name,
                //     message: err.message,
                //     stack: JSON.stringify(err.stack),
                //     method: params.method
                // });
                failedAction(err);
            });
    }

    get(route: string, sessionId: string, tag: string, failedAction: Function, successAction: Function) {
        const params = {
            method: 'GET',
            headers: this.getHeaders(sessionId)
        };
        return this.executeFetch(route, params, tag, failedAction, successAction);
    }

    getWithoutHeaders(route: string, tag: string, failedAction: Function, successAction: Function) {
        const params = {
            method: 'GET',
            headers: {
                Authorization: 'Bearer d5f414add21b402ea09486735956582c904cf94c'
            }
        };

        return this.executeFetch(route, params, tag, failedAction, successAction);
    }

    getSISessionToken() {
        return this.cookies.get('SI_SESSION_TOKEN');
    }

    isSportsInsights() {
        return environment.isSportsInsightsUrl || !!this.getSISessionToken();
    }

    getHeaders(sessionId: string) {
        const sportsInsightsToken = this.getSISessionToken();
        let headers = {
            'Content-Type': 'application/json',
            Authorization: 'Bearer d5f414add21b402ea09486735956582c904cf94c',
            FLSessionId: sessionId
        };

        if (!!sportsInsightsToken) {
            headers = {
                'Content-Type': 'application/json',
                Authorization: 'Bearer d5f414add21b402ea09486735956582c904cf94c',
                SISessionId: this.getSISessionToken()
            };
        }

        return headers;
    }

    post(
        route: string,
        sessionId: string,
        body: ?string,
        tag: string,
        failedAction: Function,
        successAction: Function
    ) {
        const params = {
            method: 'POST',
            headers: this.getHeaders(sessionId),
            body: ''
        };

        if (!!body && body !== '') {
            params.body = body;
        }

        return this.executeFetch(route, params, tag, failedAction, successAction);
    }

    postWithoutHeaders(route: string, sessionId: string, tag: string, failedAction: Function, successAction: Function) {
        const params = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        };

        return this.executeFetch(route, params, tag, failedAction, successAction);
    }

    getAllSports(sessionId: string, failedAction: Function, successAction: Function) {
        const route = `${baseUrl}/sports`;
        return this.get(route, sessionId, 'sports', failedAction, successAction);
    }

    getSourcesForSport(sportName: string, sessionId: string, failedAction: Function, successAction: Function) {
        const route = `${baseUrl}/sources/?sport=${sportName}`;
        return this.get(route, sessionId, 'sources', failedAction, successAction);
    }

    getPlayerDetails(
        playerId: number,
        propsDate: string,
        sessionId: string,
        failedAction: Function,
        successAction: Function
    ) {
        const route = `${testUrl}/player-detail/?player_id=${playerId}&propsDate=${propsDate}`;
        return this.get(route, sessionId, 'player_details', failedAction, successAction);
    }

    getPlayerNews(playerId: number, sessionId: string, failedAction: Function, successAction: Function) {
        const route = `${baseUrl}/player-news/?player_id=${playerId}`;
        return this.get(route, sessionId, 'player_news', failedAction, successAction);
    }

    getGamelogs(
        playerId: number,
        sport: string,
        start_date: string,
        end_date: string,
        sessionId: string,
        failedAction: Function,
        successAction: Function
    ) {
        const route = `${baseUrl}/player/gamelogs/?player_id=${playerId}&sport=${sport}&start_date=${start_date}&end_date=${end_date}`;
        return this.get(route, sessionId, 'gamelogs', failedAction, successAction);
    }

    getArticlesForSport(sportName: string, failedAction: Function, successAction: Function) {
        const route = `${baseUrl}/articles/?tag=${sportName}`;
        return this.getWithoutHeaders(route, 'articles', failedAction, successAction);
    }

    getUserDetails(sessionId: string, failedAction: Function, successAction: Function) {
        const route = `${baseUrl}/user-roles`;
        return this.get(route, sessionId, 'userDetails', failedAction, successAction);
    }

    logoutUser(sessionId: string, failedAction: Function, successAction: Function) {
        const route = `${environment.fantasyLabsUrl}/api/account/logout/`;
        return this.postWithoutHeaders(route, sessionId, 'logoutUser', failedAction, successAction);
    }

    getPropsForSport(
        sessionId: string,
        sportId: number,
        startDate: string,
        endDate: string,
        failedAction: Function,
        successAction: Function
    ) {
        const route = `${testUrl}/props/?sport_id=${sportId}&date=${startDate}&end_date=${endDate}`;
        return this.get(route, sessionId, 'props', failedAction, successAction);
    }

    getSportEvents(sessionId: string, sportId: number, date: string, failedAction: Function, successAction: Function) {
        const route = `${testUrl}/events/${sportId}?date=${date}`;
        return this.get(route, sessionId, 'sportEvents', failedAction, successAction);
    }

    getPropsResults(
        sessionId: string,
        sportId: number,
        startDate: string,
        endDate: string,
        teamId: number,
        oppTeamId: number,
        position: string,
        statId: number,
        sportsbook: string,
        playerName: string,
        side: string,
        failedAction: Function,
        successAction: Function
    ) {
        const route = `${testUrl}/props/results/?sport_id=${sportId}&start_date=${startDate}&end_date=${endDate}&team_ids=${teamId}&opp_team_ids=${oppTeamId}&positions=${position}&stats=${statId}&sportsbooks=${sportsbook}&player_name=${playerName}&side=${side}`;
        return this.get(route, sessionId, 'propsResults', failedAction, successAction);
    }

    getTeamsByDateRange(
        sessionId: string,
        sportId: number,
        startDate: string,
        endDate: string,
        failedAction: Function,
        successAction: Function
    ) {
        const route = `${testUrl}/events/teams/${sportId}?start_date=${startDate}&end_date=${endDate}`;
        return this.get(route, sessionId, 'teams', failedAction, successAction);
    }
}



// WEBPACK FOOTER //
// ./src/services/fantasyLabsService.js